export default __webpack_public_path__ + "static/media/LOGORplc.2a5ba649.jpeg";